import React from 'react';
import Cookies from 'js-cookie';
import { destroyCookies } from '../../login/login_logic';
import { Badge } from 'react-bootstrap';
import { NewClassRequest } from '../../classes/NewClassRequest';
import { beginIntentionalLogout, LOGOUT_NOTICE_KEY } from '../../../services/sessionExpiration';
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////FUNCION QUE TRAE LOS DATOS DE LAS TABLAS/////////////////////////////////////////////////////////////////

export const logOut = async (props, handleFreeMemorySessionManager) => {
  // Logout intencional: suprime el aviso de "sesión iniciada en otro dispositivo"
  // por si el token ya estaba invalidado en el servidor.
  beginIntentionalLogout();

  const { token_02, uid_02, client_02 } = Cookies.get();

  const request = new NewClassRequest(
    `${process.env.REACT_APP_URL_API_LARAVEL}/auth/sign_out`,
    'delete',
    null,
    {
      access_token_name: token_02,
      uid_name: uid_02,
      client_name: client_02,
    }
  );

  try {
    // Intento best-effort de revocar el token en el servidor. Si el token ya no
    // es válido (sesión invalidada por login en otro navegador), la respuesta
    // será un error: lo ignoramos y limpiamos la sesión local de todos modos.
    await request.executeRequest();
  } catch (e) {
    // Ignorado a propósito: el cierre local no debe depender del servidor.
  } finally {
    // Aviso flash de cierre correcto para mostrar en la pantalla de login.
    try {
      sessionStorage.setItem(LOGOUT_NOTICE_KEY, 'Sesión cerrada correctamente.');
    } catch (e) {
      // sessionStorage puede no estar disponible; el cierre continúa igual.
    }

    if (handleFreeMemorySessionManager) handleFreeMemorySessionManager();
    destroyCookies();

    // Recarga completa en la raíz: limpia el estado de React y evita
    // peticiones residuales tras el cierre de sesión.
    window.location.assign('/');
  }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function capital_letter(str) {
  str = str.trim();
  str = str.split(' ');

  for (var i = 0, x = str.length; i < x; i++) {
    str[i] = str[i][0].toUpperCase() + str[i].substr(1);
  }

  return str.join(' ');
}

export const setImgAvatar = (countAlerts) => {
  const { isAuth_02, names_02, paternal_surname_02 } = Cookies.get();

  if (isAuth_02) {
    return (
      <div className="pull-right">
        <Badge
          className="pull-right mL-10"
          pill
          variant="danger"
          style={
            countAlerts === 0
              ? {
                  display: 'none',
                  float: 'left',
                }
              : {
                  display: 'inline-block',
                  float: 'left',
                }
          }
        >
          {countAlerts !== 0 ? countAlerts : 0}
        </Badge>{' '}
        <span style={{ display: 'inline-block', float: 'right' }}>
          {names_02}{' '}
          {paternal_surname_02 !== 'null' && paternal_surname_02 !== null && paternal_surname_02}
        </span>
      </div>
    );
  } else {
    return '';
  }
};
